import React from "react";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Dialog from "components/Dialog/Dialog";
import { selectors as JobDetailSelectors } from "store/modules/jobDetails";
import { useTranslation } from "react-i18next";

function DecreasePositionsDialog(props) {
  const { open, onClose, onCancel, onConfirm, value, onChange } = props;
  const { t } = useTranslation();
  const intValue = parseInt(value, 10);
  const positionsFilled = useSelector(JobDetailSelectors.getPositionsFilled);
  const desiredPositions = useSelector(JobDetailSelectors.getPeopleNeeded) - intValue;

  const isValidDecrease =
    positionsFilled <= desiredPositions && desiredPositions > 0 && intValue > 0;

  return (
    <Dialog
      open={open}
      title=""
      description={null}
      onClose={onClose}
      onConfirm={onConfirm}
      onCancel={onCancel}
      alertType="question"
      icon="exposure_neg_1"
      disabled={!isValidDecrease}>
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1" align="center">
          {t(`page_job_details_dialog_positions_info`)}
        </Typography>
        <TextField
          placeholder={t("page_job_details_dialog_decrease_positions_field_placeholder")}
          helperText={t("page_job_details_dialog_decrease_positions_field_helpet_text")}
          value={value}
          onChange={onChange}
          type="number"
          margin="normal"
          inputProps={{ min: 1 }}
        />
      </Grid>
    </Dialog>
  );
}

export default DecreasePositionsDialog;
